import {useCustomQuery} from "../../../query/queryClient";
import {queryHttp} from "../../../query/queryHttp";
import {dataSourceListUrl} from "../services/supplier360Urls";
import type {SupplierDataSource} from "../types/Supplier360Types";

/**
 * Every `DataSource` (`GET data/source/`, docs §2.24) — the options behind the Raw view's Source
 * column filter. Unpaginated by the endpoint itself: a bare array of a handful of rows.
 */
export function useDataSourcesQuery() {
    const url = dataSourceListUrl();
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<SupplierDataSource[]>(url)).data,
        staleTime: Infinity,
    });
}
